import { Button, Grid } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import BackButton from "../BackButton";
import InputImageFieldGrid from "../common/InputImageFieldGrid";
import InputTextFieldGrid from "../common/InputTextFieldGrid";
import CustomButton from "components/CustomButton";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const DenominationExtraForm = ({
  title,
  goBack,
  defaultValues,
  submit,
}) => {
  const navigate = useNavigate();
  const { currentOperator } = useSelector((store) => store.operators);
  const { currentSegment } = useSelector((store) => store.segments);
  const { currentDenomination } = useSelector((store) => store.denominations);
  const { control, handleSubmit } = useForm({ defaultValues });

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title">
          <div className="title">Recargas Celular - Denominaciones</div>
          <div className="subtitle">{currentOperator.name} {currentSegment.name} {currentDenomination.denomination} </div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Grid
          container
          m={"20px"}
          maxWidth={"70%"}
          justifyContent="center"
        >
          <Grid
            container
            item
            direction="column"
            justifyContent="center"
            alignItems="center"
            wrap="nowrap"
            xs={4}
            spacing={3}
          >
            <InputTextFieldGrid
              control={control}
              name="extra_data"
              label="Datos"
              xs={2}
            />
            <InputTextFieldGrid
              control={control}
              name="validity"
              label="Vigencia"
              xs={2}
            />
            <InputTextFieldGrid
              control={control}
              name="name"
              label="Nombre"
              required={"Debes agregar un nombre a la denominación extra"}
              xs={2}
            />
            <InputTextFieldGrid
              control={control}
              name="description"
              multiline={true}
              label="Descripción"
              xs={2}
            />
            <InputTextFieldGrid
              control={control}
              name="gb"
              label="GB"
              xs={2}
            />
          </Grid>
          <Grid
            container
            item
            direction="column"
            justifyContent="center"
            alignItems="center"
            xs={4}
          >
            <InputImageFieldGrid
              control={control}
              name="file"
              label={"Logo"}
              xs={4}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <CustomButton
            click={handleSubmit(submit)}
            name={"Guardar"}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default DenominationExtraForm;
